import React, { forwardRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Link from "@mui/material/Link";
import Button from '@mui/joy/Button';

import PasswrodIcon from '../../assets/icons/passwordIcon.svg'
import BackIcon from '../../assets/icons/backIcon.svg'

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';



import { changePassword } from '../../Api/ForgetPassword';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const schema = yup.object({
    code: yup.string().required("OTP مطلوب"),
    password: yup.string().required("الرقم السري مطلوب"),
    c_password: yup.string().required("تاكيد الرقم السري مطلوب"),

})

export default function EnterNewPassword() {
    const navigate = useNavigate()
    const [loadingApi, setLoadingApi] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            code: "",
            password: "",
            c_password: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState

    const handleClick = () => {
        setOpenAlert(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    }

    const changeNewPassword = async (data) => {
        setLoadingApi(true)
        try {
            const res = await changePassword(data);
            if (res) {
                setMessageAlert("تم تغير كلمة المرور بنجاح")
                setOpenAlert(true)
                setLoadingApi(false)
                setTimeout(() => {
                    navigate('/')
                },3000)
            }
        } catch (error) {
            if (error.response) {
                setLoadingApi(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            <Box sx={{
                width: '80%',
                backgroundColor: '#FFF',
                borderRadius: '30px',
                border: '1px solid #60A5DC',
                margin: 'auto',
                marginTop: '40px',
                padding: '70px 0'
            }}
            >
                <Link href="/forget-password" variant="body2"
                    sx={{
                        textAlign: 'end',
                        textDecoration: 'none',
                        padding: '0 10%'
                    }}>
                    <img src={BackIcon} alt='back icon' />
                </Link>
                <form onSubmit={handleSubmit(changeNewPassword)}>
                    <Stack spacing={5} sx={{ width: '80%', margin: 'auto', marginTop: '50px' }}>
                        <FormControl sx={{ width: '50%' }}>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>ادخل رمز التحقق OTP</FormLabel>
                            <Input
                                type='number'
                                placeholder="ادخل رمز التحقق OTP"
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('code')}
                            />
                            {errors.code &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.code?.message}</Typography>
                            }
                        </FormControl>

                        <FormControl>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>كلمة المرور الجديدة</FormLabel>
                            <Input
                                type='password'
                                placeholder="****************"
                                startDecorator={<img src={PasswrodIcon}
                                    alt='email icon' />}
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('password')}
                            />
                            {errors.password &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.password?.message}</Typography>
                            }
                        </FormControl>

                        <FormControl>
                            <FormLabel sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>تأكيد كلمة المرور الجديدة</FormLabel>
                            <Input
                                type='password'
                                placeholder="****************"
                                startDecorator={<img src={PasswrodIcon}
                                    alt='email icon' />}
                                sx={{ height: '60px', borderRadius: '30px' }}
                                {...register('c_password')}
                            />
                            {errors.c_password &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.c_password?.message}</Typography>
                            }
                        </FormControl>

                        <Button
                            type='submit'
                            // onClick={navigateLognPage}
                            loading={loadingApi}
                            sx={{ height: '60px', backgroundColor: '#3E64F4', color: '#FFF', fontSize: '20px', borderRadius: '30px' }}
                        >انشاء كلمة المرور الجديدة</Button>
                    </Stack>
                </form>
            </Box>
        </>
    )
}